export const statisticCount = {
  download: 4746441,
  registrations: 4314947,
  fire: 21668949,
  case: 12865296,
  box: 65318514,
  nft: 46378
}